var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bullets),function(i){return _c('div',{key:i,style:(("font-size:" + _vm.fontSize + "px"))},[_c('li',{style:(_vm.bulletCss)},[_vm._v(_vm._s(i))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }